import axiosClient from './axiosClient';
import { ProjectTeamModel } from '../Models/projectTeamModel';

const projectTeamService = {
  getAll: () => {
    return axiosClient.get('/ProjectTeam')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /ProjectTeam returned 404. Falling back to GET /project-teams...");
          return axiosClient.get('/project-teams');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(ProjectTeamModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (teamID) => {
    return axiosClient.get(`/ProjectTeam/${teamID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /ProjectTeam/${teamID} returned 404. Falling back to GET /project-teams/${teamID}...`);
          return axiosClient.get(`/project-teams/${teamID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectTeamModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = ProjectTeamModel.toBackend(payload);
    body.teamId = 0;

    return axiosClient.post('/ProjectTeam', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /ProjectTeam returned 404. Falling back to POST /project-teams...");
          return axiosClient.post('/project-teams', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectTeamModel.toFrontend(raw),
        };
      });
  },

  update: (teamID, payload) => {
    const body = ProjectTeamModel.toBackend({ ...payload, teamID });

    return axiosClient.put('/ProjectTeam', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /ProjectTeam returned 404. Falling back to PUT /project-teams...");
          return axiosClient.put('/project-teams', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ProjectTeamModel.toFrontend(raw),
        };
      });
  },

  remove: (teamID) => {
    return axiosClient.delete(`/ProjectTeam/${teamID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /ProjectTeam/${teamID} returned 404. Falling back to DELETE /project-teams/${teamID}...`);
          return axiosClient.delete(`/project-teams/${teamID}`);
        }
        return Promise.reject(err);
      });
  },
};

export default projectTeamService;
